/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-16 16:45:52
 */
import { CHANGE_STATUS, CHANGE_PAGE } from '../constant';
import { nanotubeType } from './types';

const defaultStates: nanotubeType = {
  nanotube: false, // 是否是纳管中
  pageStep: '',
};

const page = (state = { ...defaultStates }, action: any) => {
  const { type, payload } = action;

  switch (type) {
    // 设置纳管状态
    case CHANGE_STATUS: {
      return {
        ...state,
        nanotube: payload,
      };
    }
    // 设置页面
    case CHANGE_PAGE: {
      return {
        ...state,
        pageStep: payload,
      };
    }
    default:
      return state;
  }
};

export default page;
